import React from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import { leaseDateFormat } from "../../utils/utils";
class CamDetails extends React.Component {
  countError = "";
  state = {
    escalationIndex: 0,
    periodDurationDD: "",
    periodDurationYY: "",
    periodDurationMM: "",
    disableOnEdit: false,
    currentIndex: null,
    readOnEdit: false,
    applicableValue: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    revalue: "",
    to: "",
    showCamActalization: false,
    showCamCapped: false,
    showAddBtn: false,
    isOpen: false,
    showForm: true,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    redirect: false,
    camDetails: [],
    camBasisRate: false,
    camBasisPureRevenueShare: false,
    camBasisPureRevenueShareSalesRange: false,
    camBasisPercentofRent: false,
    initialValues: {
      camLogic: {
        fromDate: "",
        toDate: "",
        camUom: "",
        camDueDate: "",
        camRate: "",
        camRateTerm: "",
        onArea: "",
        camFrequency: "",
        camLogicValue: "",
        camLogicText: "",
        rentUom: "",
        rentRate: "",
        percentageofRent: "",
        slabs: [],
        camActualizationPeriod: "",
        unit: "",
      },
      totalSlabs: "",
    },
    toggleCamForm: false,
    biFurcateRentVal: 0,
    units: [],
    isUnitBifurcate: false,
    isRentAutocalculate: false,
    isRentCheckboxChecked: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  showCamForm = (e) => {
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value === "yes") {
      this.setState({
        toggleCamForm: true,
      });
    } else {
      this.setState({
        toggleCamForm: false,
      });
    }
  };

  biFurcateRent(e, values) {
    if (this.state.camDetails.length > 0) {
      var answer = window.confirm(
        "This will remove all the current rental details, are you sure want to do this?"
      );
      if (answer) {
        this.setState({
          camDetails: [],
          period: 1,
          showForm: true,
          showAddBtn: true,
          fromDate: values.from,
        });
        if (e.target.checked) {
          this.setState({ biFurcateRentVal: 1 });
        } else {
          this.setState({ biFurcateRentVal: 0 });
        }
      } else {
        return false;
      }
    } else {
      if (e.target.checked) {
        this.setState({ biFurcateRentVal: 1 });
      } else {
        this.setState({ biFurcateRentVal: 0 });
      }
    }
    if (this.state.isUnitBifurcate === false) {
      this.setState({ isUnitBifurcate: true });
    } else {
      this.setState({ isUnitBifurcate: false });
    }
  }

  autocalculateRent = (e, values) => {
    if (this.state.camDetails.length > 0) {
      var answer = window.confirm(
        "This will remove all the current rental details, are you sure want to do this?"
      );
      if (answer) {
        this.setState({
          camDetails: [],
          period: 1,
          showForm: true,
          showAddBtn: true,
        });
        if (e.target.checked) {
          this.setState({
            isRentAutocalculate: true,
            isRentCheckboxChecked: true,
          });
        } else {
          this.setState({
            isRentAutocalculate: false,
          });
        }
      } else {
        this.setState({
          isRentCheckboxChecked: false,
          isRentAutocalculate: false,
        });
        return false;
      }
    }
    if (this.state.isRentCheckboxChecked === false) {
      this.setState({ isRentCheckboxChecked: true, isRentAutocalculate: true });
    } else {
      this.setState({
        isRentCheckboxChecked: false,
        isRentAutocalculate: false,
        fromDate: values.from,
      });
    }
  };

  handleUnitOnChange(e, values) {
    this.state.initialValues.camLogic.unit = e.target.value;
    this.setState({});
    if (this.state.camDetails.length > 0) {
      var bifurcatedArr = this.state.camDetails.filter(
        (unit) => unit.unit === e.target.value
      );
      if (bifurcatedArr.length > 0) {
        if (bifurcatedArr[bifurcatedArr.length - 1]["toDate"] === values.to) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Values For this unit has completed the period",
          });
          return false;
        }
        this.state.period = bifurcatedArr[bifurcatedArr.length - 1].period + 1;
        this.setState({
          fromDate: getToDate(
            bifurcatedArr[bifurcatedArr.length - 1].toDate,
            2,
            0,
            0
          ),
          toDate: "",
        });
      } else {
        this.state.period = 1;
        this.state.fromDate = values.from;
        this.setState({});
      }
    } else {
      this.state.period = 1;
      this.state.fromDate = values.from;
      this.setState({});
    }
  }

  calculateRent = (values) => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      return false;
    }
    let currentValues = values;
    let nextPeriodDateStart = currentValues.from;
    let _camDetails = this.state.camDetails;
    let currentPeriod = 0;
    var periodToDate;
    var endDate = currentValues.to;
    var escPercent = Number(currentValues.camLogic.escalationPercent);
    while (periodToDate !== endDate) {
      currentPeriod++;
      var periodStartDate = nextPeriodDateStart;
      periodToDate = getToDate(
        periodStartDate,
        this.state.periodDurationDD,
        this.state.periodDurationMM,
        this.state.periodDurationYY
      );
      if (
        new Date(periodToDate).getTime() > new Date(currentValues.to).getTime()
      ) {
        periodToDate = currentValues.to;
      }
      if (currentPeriod > 1) {
        currentValues.camLogic.camRate = (
          Number(currentValues.camLogic.camRate) *
          (Number(currentValues.camLogic.escalationPercent) / 100) +
          Number(currentValues.camLogic.camRate)
        ).toFixed(2);
      }

      var camLogic = { ...currentValues.camLogic };
      var _currentValues = {
        fromDate: periodStartDate,
        toDate: periodToDate,
        camLogicText: this.state.initialValues.camLogic.camLogicText,
        camLogicValue: this.state.initialValues.camLogic.camLogicValue,
        periodDurationDD: this.state.periodDurationDD,
        periodDurationMM: this.state.periodDurationMM,
        periodDurationYY: this.state.periodDurationYY,
        periodTermDD: this.state.periodDurationDD,
        periodTermMM: this.state.periodDurationMM,
        periodTermYY: this.state.periodDurationYY,
        period: currentPeriod,
        slabs: [],
        escalationPercent: camLogic.escalationPercent,
        camUom: camLogic.camUom,
        onArea: camLogic.onArea,
        camRateTerm: camLogic.camRateTerm,
        rentRate: camLogic.rentRate,
        camRate: camLogic.camRate,
        camFrequency: camLogic.camFrequency,
        camDueDate: camLogic.camDueDate,
        camDueType: camLogic.camDueType,
        camDueFrequency: camLogic.camDueFrequency,
        camActualization: camLogic.camActualization,
        camActualizationBasis: camLogic.camActualizationBasis,
        camActualizationPeriod: camLogic.camActualizationPeriod,
        camCapped: camLogic.camCapped,
        camCappedUom: camLogic.camCappedUom,
        camCappedRate: camLogic.camCappedRate,
        camCappedRateTerm: camLogic.camCappedRateTerm,
        minusCamPercent: camLogic.minusCamPercent,
        unit: camLogic.unit,
      };
      console.log(_currentValues);
      _camDetails.push(_currentValues);
      nextPeriodDateStart = getToDate(periodToDate, 2, 0, 0);
    }
    this.setState({ camDetails: _camDetails });
    values.camLogic.escalationPercent = "";
    values.camLogic.rentRate = "";
    this.setState({
      periodDurationDD: "",
      periodDurationMM: "",
      periodDurationYY: "",
    });
  };

  changeCamActualization(e) {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value == "Yes") {
      this.setState({
        showCamActalization: true,
      });
    } else {
      this.setState({
        showCamActalization: false,
      });
    }
  }

  changeCamCapped(e) {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value == "Yes") {
      this.setState({
        showCamCapped: true,
      });
    } else {
      this.setState({
        showCamCapped: false,
      });
    }
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  editCam(index, values) {
    if (this.state.camDetails[index].unit !== undefined) {
      this.setState({ isUnitBifurcate: true, biFurcateRentVal: 1 });
    } else {
      this.setState({ isUnitBifurcate: false, biFurcateRentVal: 0 });
    }
    if (this.state.camDetails[index].camLogic !== undefined) {
      if (
        this.state.camDetails[index].camLogic.escalationPercent !== undefined
      ) {
        this.setState({
          isRentAutocalculate: true,
          isRentCheckboxChecked: true,
        });
      } else {
        this.setState({
          isRentAutocalculate: false,
          isRentCheckboxChecked: false,
        });
      }
    } else {
      this.setState({
        isRentAutocalculate: false,
        isRentCheckboxChecked: false,
      });
    }
    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;

    if (this.state.camDetails[index].camCapped == "Yes") {
      this.setState({ showCamCapped: true });
    } else {
      this.setState({ showCamCapped: false });
    }
    this.state.period = this.state.camDetails[index].period;
    this.state.initialValues.totalSlabs =
      this.state.camDetails[index].slabNumber;
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.camDetails[index].periodTermDD,
      periodTermMM: this.state.camDetails[index].periodTermMM,
      periodTermYY: this.state.camDetails[index].periodTermYY,
    });
    if (this.state.camDetails[index].camLogicValue === "1") {
      this.setState({
        camBasisRate: true,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: false,
      });
    } else if (this.state.camDetails[index].camLogicValue === "2") {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: true,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: false,
      });
    } else if (this.state.camDetails[index].camLogicValue === "3") {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: true,
        camBasisPercentofRent: false,
      });
    } else if (this.state.camDetails[index].camLogicValue === "4") {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: true,
      });
    } else {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: false,
      });
    }
    values.camLogic = { ...this.state.camDetails[index] };
    this.state.fromDate = this.state.camDetails[index].fromDate;
    this.state.toDate = this.state.camDetails[index].toDate;
    if (this.state.camDetails[index].camActualization == "Yes") {
      this.setState({ showCamActalization: true });
    } else {
      this.setState({ showCamActalization: false });
    }
    if (this.state.camDetails[index].camCapped == "Yes") {
      this.setState({ showCamCapped: true });
    } else {
      this.setState({ showCamCapped: false });
    }
    this.setState({});
  }

  addCamDetails = (values, resetForm, setFieldValue) => {
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      } else if (this.state.toDate == values.to) {
        this.state.showForm = false;
        this.state.showAddBtn = false;
      }
      values.camLogic.camLogicText =
        this.state.initialValues.camLogic.camLogicText;
      var _camDetails = this.state.camDetails;
      values.camLogic.period = this.state.period;
      values.camLogic.fromDate = this.state.fromDate;
      values.camLogic.toDate = this.state.toDate;
      values.camLogic.periodTermYY = this.state.periodTermYY;
      values.camLogic.periodTermMM = this.state.periodTermMM;
      values.camLogic.periodTermDD = this.state.periodTermDD;
      values.camLogic.unit = this.state.initialValues.camLogic.unit;
      _camDetails.push(values.camLogic);
      var _initialValues = this.state.initialValues;
      // _initialValues.camLogic.camLogicValue = "";
      _initialValues.camLogic.slabs = [];
      this.setState({
        camDetails: _camDetails,
        // camBasisRate: false,
        // camBasisPureRevenueShare: false,
        // camBasisPureRevenueShareSalesRange: false,
        // camBasisPercentofRent: false,
      });
      this.state.period++;
      // this.state.fromDate = this.state.toDate;
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.camDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      // resetForm();
      setFieldValue("camLogic.camRate", "");
      setFieldValue("camLogic.escalationPercent", "");
      this.setState({ isEdit: false, escalationIndex: this.state.period - 2 });
    } else {
      console.log("hiii sumeet");
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      } else if (this.state.toDate == values.to) {
        this.state.showForm = false;
        this.state.showAddBtn = false;
      }
      values.camLogic.camLogicText =
        this.state.initialValues.camLogic.camLogicText;
      var _camDetails = this.state.camDetails;
      values.camLogic.period = this.state.period;
      values.camLogic.fromDate = this.state.fromDate;
      values.camLogic.toDate = this.state.toDate;
      values.camLogic.periodTermYY = this.state.periodTermYY;
      values.camLogic.periodTermMM = this.state.periodTermMM;
      values.camLogic.periodTermDD = this.state.periodTermDD;
      // _camDetails.push(values.camLogic);
      _camDetails[this.state.currentIndex] = { ...values.camLogic };
      var _initialValues = this.state.initialValues;
      // _initialValues.camLogic.camLogicValue = "";
      _initialValues.camLogic.slabs = [];
      this.setState({
        camDetails: _camDetails,
        // camBasisRate: false,
        // camBasisPureRevenueShare: false,
        // camBasisPureRevenueShareSalesRange: false,
        // camBasisPercentofRent: false,
      });
      this.state.period++;
      // this.state.fromDate = this.state.toDate;
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.camDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      // resetForm();
      this.state.currentIndex = null;
      this.state.disableOnEdit = false;
      this.state.readOnEdit = false;
      this.setState({ isEdit: false, escalationIndex: this.state.period - 1 });
      console.log(this.state.camDetails[
        this.state.escalationIndex
      ].camRate);
      console.log(this.state.camDetails[
        this.state.escalationIndex
      ])
      console.log(this.state.escalationIndex)
    }
  };

  resetCamDetails = (values, resetForm) => {
    var _initialValues = this.state.initialValues;
    _initialValues.camLogic.camLogicValue = "";
    _initialValues.camLogic.slabs = [];
    this.setState({
      // camDetails: _camDetails,
      camBasisRate: false,
      camBasisPureRevenueShare: false,
      camBasisPureRevenueShareSalesRange: false,
      camBasisPercentofRent: false,
    });
    this.state.period++;
    // this.state.fromDate = this.state.toDate;
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.camDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
    resetForm();
  };

  handleReset = () => {
    var _initialValues = this.state.initialValues;
    _initialValues.camLogic.camLogicValue = "";
    _initialValues.camLogic.slabs = [];
    this.setState({
      // camDetails: _camDetails,
      camBasisRate: false,
      camBasisPureRevenueShare: false,
      camBasisPureRevenueShareSalesRange: false,
      camBasisPercentofRent: false,
    });
    this.state.period++;
    // this.state.fromDate = this.state.toDate;
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.camDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
  };

  hadleCamLogicChange = (event) => {
    console.log(this.state.camDetails);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (event.target.value === "") {
      this.state.showAddBtn = false;
    } else {
      this.state.showAddBtn = true;
    }
    var index1 = event.nativeEvent.target.selectedIndex;
    var text = event.nativeEvent.target[index1].label;
    this.state.initialValues.camLogic.camLogicText = text;
    this.state.initialValues.camLogic.camLogicValue = event.target.value;
    if (event.target.value === "1") {
      this.setState({
        camBasisRate: true,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: false,
      });
    } else if (event.target.value === "2") {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: true,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: false,
      });
    } else if (event.target.value === "3") {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: true,
        camBasisPercentofRent: false,
      });
    } else if (event.target.value === "4") {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: true,
      });
    } else {
      this.setState({
        camBasisRate: false,
        camBasisPureRevenueShare: false,
        camBasisPureRevenueShareSalesRange: false,
        camBasisPercentofRent: false,
      });
    }
  };

  addSlabRow = (e) => {
    console.log(e.target.value, "vv");
    this.state.initialValues.totalSlabs = e.target.value;
    if (this.state.initialValues.camLogic.slabs.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.camLogic.slabs.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.camLogic.slabs.push({
          from: "",
          to: "",
          percent: "",
        });
      }
    } else if (
      this.state.initialValues.camLogic.slabs.length > e.target.value
    ) {
      var toRemove =
        this.state.initialValues.camLogic.slabs.length - e.target.value;
      for (var i = 0; i < toRemove; i++) {
        this.state.initialValues.camLogic.slabs.pop({});
      }
    }
  };

  getFromForNextSlab(e, values, index) {
    this.state.initialValues.camLogic.slabs[index + 1].from =
      Number(e.target.value) + Number(1);
    this.setState({});
  }

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  componentDidMount() {

    let athis=this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-cam-details?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      athis.state.fromDate = data.from;
      athis.state.to = data.to;
      athis.state.applicableValue = data.camApplicable;
      if (data.camDetails.length > 0) {
        if (data.camDetails[data.camDetails.length - 1].toDate == data.to) {
          athis.setState({
            showForm: false,
          });
        }
        athis.setState({
          fromDate: getToDate(
            data.camDetails[data.camDetails.length - 1].toDate,
            2,
            0,
            0
          ),
        });
      }
      if (data.camApplicable === "yes") {
        athis.setState({
          toggleCamForm: true,
        });
      } else {
        athis.setState({
          toggleCamForm: false,
        });
      }
      athis.setState({
        initialValues: data,
        units: data.units,
        camDetails: data.camDetails,
        renewalLeaseTermDD: data.renewalLeaseTermDD,
        renewalLeaseTermMM: data.renewalLeaseTermMM,
        renewalLeaseTermYY: data.renewalLeaseTermYY,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        period: data.camDetails.length > 0 ? data.camDetails.length + 1 : 1,
      });
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-cam-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.fromDate = data.from;
    //     this.state.to = data.to;
    //     this.state.applicableValue = data.camApplicable;
    //     if (data.camDetails.length > 0) {
    //       if (data.camDetails[data.camDetails.length - 1].toDate == data.to) {
    //         this.setState({
    //           showForm: false,
    //         });
    //       }
    //       // let _tempDate = new Date(
    //       //   data.camDetails[data.camDetails.length - 1].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.camDetails[data.camDetails.length - 1].toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     if (data.camApplicable === "yes") {
    //       this.setState({
    //         toggleCamForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleCamForm: false,
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       units: data.units,
    //       camDetails: data.camDetails,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       period: data.camDetails.length > 0 ? data.camDetails.length + 1 : 1,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _cam = this.state.camDetails;
    _cam.splice(this.state.index_val, 1);
    console.log(_cam, "new array");
    this.setState({
      camDetails: _cam,
      showForm: true,
    });
    this.state.period--;
    if (this.state.camDetails.length > 0) {
      this.setState({
        fromDate: getToDate(
          this.state.camDetails[this.state.camDetails.length - 1].toDate,
          2,
          0,
          0
        ),
      });
    } else {
      this.setState({
        fromDate: this.state.revalue,
      });
    }
    this.setState({
      delete: false,
      index_val: "",
      revalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  calculateRentRate(e, values, setFieldValue) {
    if (this.state.period > 1) {
      setFieldValue(
        "camLogic.camRate",
        (
          Number(
            this.state.camDetails[this.state.camDetails.length - 1].camRate
          ) *
          (1 + Number(e.target.value) / 100)
        ).toFixed(2)
      );
    }
  }

  calculateEscalationPercent(e, values, setFieldValue) {
    if (
      this.state.period > 1 &&
      this.state.camDetails[this.state.escalationIndex].camRate !== 0
    ) {
      setFieldValue(
        "camLogic.escalationPercent",
        (
          ((Number(e.target.value) -
            Number(this.state.camDetails[this.state.escalationIndex].camRate)) /
            Number(
              this.state.camDetails[this.state.camDetails.length - 1].camRate
            )) *
          100
        ).toFixed(2)
      );
    }
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;
      return (
        <Redirect
          push
          //to={"/createlease/utilities/" + this.props.match.params.id}
          to={`/${urlPath[1]}/lease-broker-details/` + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease">
        <div>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>Create Lease</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>Commercial Details</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">CAM Details</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              values.camApplicable = this.state.applicableValue;
              if (!this.applicableValidator.allValid()) {
                this.applicableValidator.showMessages();
                return false;
              }
              if (
                this.state.camDetails.length == 0 &&
                this.state.applicableValue !== "no"
              ) {
                this.mainFormValidator.showMessages("countError");
                return false;
              }
              if (this.state.biFurcateRentVal === 0) {
                if (
                  this.state.applicableValue == "yes" &&
                  this.state.to !==
                  this.state.camDetails[this.state.camDetails.length - 1]
                    .toDate
                ) {
                  this.setState({
                    popupalertMessage: true,
                    popupMessageContent: "Please Complete the period",
                  });
                  return false;
                }
              }
              values.camDetails = this.state.camDetails;
              values.isRentAutocalculate = this.state.isRentAutocalculate;
              values.isUnitBifurcate = this.state.isUnitBifurcate;
              var self = this;
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/create-lease/update-lease-cam-details?lease_id=${this.props.match.params.id}`,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({ messsagePopup: true });
                }
              });
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
              resetForm,
              setFieldValue,
            }) => (
              <>
                <div className="unitFormContainerNew">
                  <Form autoComplete="off">
                    <div className="newGridSectionParent">
                      <div className="d-flex gap-5">
                        <label>
                          <Field
                            style={{ width: 'min-content' }}
                            type="checkbox"
                            name="bifurcateRentCheckBox"
                            value="bifurcateRentCheckBox"
                            className="sameAs me-2"
                            checked={this.state.isUnitBifurcate}
                            disabled={
                              typeof this.state.units != "undefined" &&
                                this.state.units.length === 1
                                ? true
                                : false
                            }
                            onClick={(e) => {
                              this.biFurcateRent(e, values);
                            }}
                          />
                          BiFurcate Rent
                        </label>
                        <label>
                          <Field
                            style={{ width: 'min-content' }}
                            type="checkbox"
                            name="autocalculateRentCheckBox"
                            value="autocalculateRentCheckBox"
                            className="sameAs me-2"
                            checked={this.state.isRentCheckboxChecked}
                            onClick={(e) => {
                              this.autocalculateRent(e, values);
                            }}
                          />
                          Autocalculate Rent
                        </label>
                      </div>
                      <div className="gridColOneByThree textWithHrTag">
                        <hr className="m-0 my-4" />
                      </div>
                      <div className="newGridSectionForFormMain">
                        <div className="newGridSectionInner">
                          <label>
                            Lease Term (YY-MM-DD){" "}
                            <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <div className="row m-0">
                              <div className="col-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermYY}
                                />
                              </div>
                              <div className="col-4">
                                <Field
                                  type="text"
                                  name="leaseTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermMM}
                                />
                              </div>
                              <div className="col-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermDD}
                                />
                              </div>
                            </div>
                            <ErrorMessage
                              name="leaseTerm"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="newGridSectionInner">
                          <label>
                            Lease Renewal Term (YY-MM-DD){" "}
                            <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <div className="row m-0">
                              <div className="col-sm-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermYY}
                                />
                              </div>
                              <div className="col-sm-4">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermMM}
                                />
                              </div>
                              <div className="col-sm-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermDD}
                                />
                              </div>
                            </div>
                            <ErrorMessage
                              name="leaseRenewalTerm"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="newGridSectionInner">
                          <label>
                            From
                          </label>
                          <div className="position-relative">
                            <Field type="date" name="from" />
                            <ErrorMessage
                              name="from"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            To
                          </label>
                          <div className="position-relative">
                            <Field type="date" name="to" />
                            <ErrorMessage
                              name="to"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            CAM Applicable <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="camApplicable"
                              value={this.state.applicableValue}
                              onChange={(e) => {
                                this.state.applicableValue = e.target.value;
                                this.showCamForm(e);
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="yes" label="Yes" />
                              <option value="no" label="No" />
                            </Field>
                            {this.applicableValidator.message(
                              "CAM Applicable",
                              this.state.applicableValue,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        {this.state.showForm && (
                          <div className="newGridSectionInner">
                            <label>
                              CAM Paid At <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="camLogic.camPaidAt"
                                disabled={this.state.disableOnEdit}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="average" label="Average" />
                                <option value="actual" label="Actual" />
                              </Field>
                            </div>
                          </div>
                        )}

                        {this.state.biFurcateRentVal === 1 && (
                          <div className="newGridSectionInner">
                            <label>
                              Unit <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="camLogic.unit"
                                disabled={this.state.disableOnEdit}
                                value={this.state.initialValues.camLogic.unit}
                                onChange={(e) => {
                                  this.handleUnitOnChange(e, values);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.units.map((obj) => (
                                  <option key={obj.id} value={obj.unitNo}>
                                    {obj.unitNo}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                        )}

                        {this.state.toggleCamForm && (
                          <>
                            {this.state.isRentAutocalculate === false && this.state.showForm && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    Period
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="camLogic.period"
                                      disabled={this.state.disableOnEdit}
                                      value={this.state.period}
                                      onChange={(e) => {
                                        this.state.period = e.target.value;
                                      }}
                                    />
                                    <ErrorMessage
                                      name="camLogic.period"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    Period Term
                                  </label>
                                  <div className="position-relative">
                                    <div className="row m-0">
                                      <div className="col-sm-4 p-0">
                                        <Field
                                          type="text"
                                          name="periodTermYY"
                                          placeholder="YY"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermYY}
                                          onChange={(e) => {
                                            this.state.periodTermYY = e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-4">
                                        <Field
                                          type="text"
                                          name="periodTermMM"
                                          placeholder="MM"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermMM}
                                          onChange={(e) => {
                                            this.state.periodTermMM = e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-4 p-0">
                                        <Field
                                          type="text"
                                          name="periodTermDD"
                                          placeholder="DD"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermDD}
                                          onChange={(e) => {
                                            this.state.periodTermDD = e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      name="camLogic.periodTerm"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {this.state.isRentAutocalculate === true && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="camLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.camLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    Period Duration
                                  </label>
                                  <div className="position-relative">
                                    <div className="row m -0">
                                      <div className="col-sm-6 ps-0">
                                        <Field
                                          type="text"
                                          name="periodDurationYY"
                                          placeholder="YY"
                                          disabled={this.state.disableOnEdit}
                                          className="centerPlaceHolder text-center"
                                          value={this.state.periodDurationYY}
                                          onChange={(e) => {
                                            this.state.periodDurationYY = e.target.value;
                                            handleChange(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-6 pe-0">
                                        <Field
                                          type="text"
                                          name="periodDurationMM"
                                          placeholder="MM"
                                          disabled={this.state.disableOnEdit}
                                          className="centerPlaceHolder text-center"
                                          value={this.state.periodDurationMM}
                                          onChange={(e) => {
                                            this.state.periodDurationMM = e.target.value;
                                            handleChange(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-12 p-0 mt-3">
                                        <Field
                                          type="text"
                                          name="periodDurationDD"
                                          placeholder="DD"
                                          disabled={this.state.disableOnEdit}
                                          className="centerPlaceHolder text-center"
                                          value={this.state.periodDurationDD}
                                          onChange={(e) => {
                                            this.state.periodDurationDD = e.target.value;
                                            handleChange(e);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      name="rentalLogic.periodDuration"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {this.state.showForm && (
                              <div className="gridColOneByThree">
                                <div className="newGridSectionInner newGridSectionInnerForLogin">
                                  <label>
                                    CAM Logic <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camLogicValue"}
                                      value={this.state.initialValues.camLogic.camLogicValue}
                                      onChange={(e) => {
                                        handleChange(e);
                                        this.hadleCamLogicChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="1" label="CAM Basis Rate" />
                                      {this.state.isRentAutocalculate === false && (
                                        <>
                                          <option value="2" label="CAM Basis Pure Revenue Share" />
                                          <option value="3" label="CAM Basis Pure Revenue Share Sales Range" />
                                          <option value="4" label="CAM Basis % of Rent" />
                                        </>
                                      )}
                                    </Field>
                                  </div>
                                </div>
                              </div>
                            )}

                            {this.state.camBasisRate && (
                              <>
                                {this.state.isRentAutocalculate === false && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        From <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="date"
                                          name="camLogic.fromDate"
                                          readOnly={true}
                                          value={this.state.fromDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "From",
                                          this.state.fromDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>
                                        To <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="date"
                                          name="camLogic.toDate"
                                          readOnly={true}
                                          value={this.state.toDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "To",
                                          this.state.toDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM UOM <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camUom"}
                                      onChange={(e) => {
                                        this.validator = new SimpleReactValidator({
                                          autoForceUpdate: this,
                                        });
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" />
                                      <option value="Per Sq Ft" label="Per Sq Ft" />
                                      <option value="Flat Amount" label="Flat Amount" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam UOM",
                                      values.camLogic.camUom,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {values.camLogic.camUom === "Per Sq Ft" && (
                                  <div className="newGridSectionInner">
                                    <label>
                                      On Area <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"camLogic.onArea"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Usable Area" label="Usable Area" />
                                        <option value="Carpet Area" label="Carpet Area" />
                                        <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                      </Field>
                                      {this.validator.message(
                                        "On Area",
                                        values.camLogic.onArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                )}

                                {this.state.period > 1 &&
                                  typeof this.state.camDetails[this.state.escalationIndex] !== "undefined" &&
                                  this.state.camDetails[this.state.escalationIndex].camRate !== 0 &&
                                  this.state.isRentAutocalculate === false && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        Escalation %
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="camLogic.escalationPercent"
                                          disabled={this.state.disableOnEdit}
                                          onBlur={(e) => {
                                            this.calculateRentRate(e, values, setFieldValue);
                                          }}
                                        />
                                        {this.validator.message(
                                          "Escalation %",
                                          values.camLogic.escalationPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Rate <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="camLogic.camRate"
                                      onBlur={(e) => {
                                        this.calculateEscalationPercent(e, values, setFieldValue);
                                      }}
                                    />
                                    {this.validator.message(
                                      "Cam Rate",
                                      values.camLogic.camRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Rate Term <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Per Month" label="Per Month" />
                                      <option value="Per Quarter" label="Per Quarter" />
                                      <option value="Per Half Year" label="Per Half Year" />
                                      <option value="Per Year" label="Per Year" />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Rate Term",
                                      values.camLogic.camRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Frequency <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option value="Quarterly" label="Quarterly" />
                                      <option value="Half Yearly" label="Half Yearly" />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Frequency",
                                      values.camLogic.camFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Due Date <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <div className="row m-0">
                                      <div className="col-sm-6 ps-0">
                                        <Field
                                          type="number"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueDate"
                                        />
                                      </div>
                                      <div className="col-sm-6 pe-0">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueType"
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option value="Working Day" label="Working Day" />
                                        </Field>

                                      </div>
                                      <div className="col-sm-12 p-0 mt-3">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueFrequency"
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Every Month" label="Every Month" />
                                          <option value="Subsequent Month" label="Subsequent Month" />
                                          <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                          <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                          <option value="Subsequent Year" label="Subsequent Year" />
                                          <option value="Next Financial Year" label="Next Financial Year" />
                                        </Field>

                                      </div>
                                    </div>
                                    {this.validator.message(
                                      "cam Due Date",
                                      values.camLogic.camDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Actualization <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camActualization"}
                                      onChange={(e) => {
                                        this.changeCamActualization(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Actualization",
                                      values.camLogic.camActualization,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {this.state.showCamActalization && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Actualization Basis (* Times Actual Cost) <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="camLogic.camActualizationBasis"
                                        />
                                        {this.validator.message(
                                          "CAM Actualization Basis",
                                          values.camLogic.camActualizationBasis,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Actualization Period (MM)
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="camLogic.camActualizationPeriod"
                                        />
                                        <ErrorMessage
                                          name="camLogic.camActualizationPeriod"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Capped <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camCapped"}
                                      onChange={(e) => {
                                        this.changeCamCapped(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Capped",
                                      values.camLogic.camCapped,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {this.state.showCamCapped && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped UOM <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"camLogic.camCappedUom"}
                                          onChange={(e) => {
                                            this.validator = new SimpleReactValidator({
                                              autoForceUpdate: this,
                                            });
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Per Sq Ft" label="Per Sq Ft" />
                                          <option value="Flat Amount" label="Flat Amount" />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Capped Uom",
                                          values.camLogic.camCappedUom,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    {values.camLogic.camCappedUom === "Per Sq Ft" && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          CAM Capped on Area <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name={"camLogic.camCappedOnArea"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Usable Area" label="Usable Area" />
                                            <option value="Carpet Area" label="Carpet Area" />
                                            <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped On Area",
                                            values.camLogic.camCappedOnArea,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped Rate <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="camLogic.camCappedRate"
                                        />
                                        {this.validator.message(
                                          "CAM Capped Rate",
                                          values.camLogic.camCappedRate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped Rate Term <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"camLogic.camCappedRateTerm"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Daily" label="Daily" />
                                          <option value="Monthly" label="Monthly" />
                                          <option value="Quarterly" label="Quarterly" />
                                          <option value="Half Yearly" label="Half Yearly" />
                                          <option value="Yearly" label="Yearly" />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Capped Rate Term",
                                          values.camLogic.camCappedRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}

                              </>
                            )}

                            {this.state.camBasisPureRevenueShare && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="camLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="camLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    Revenue Share (%) <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="camLogic.revenueShare"
                                    />
                                    {this.validator.message(
                                      "Revenue Share",
                                      values.camLogic.revenueShare,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Rate Term <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camRateTerm"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Per Month" label="Per Month" />
                                      <option value="Per Quarter" label="Per Quarter" />
                                      <option value="Per Half Year" label="Per Half Year" />
                                      <option value="Per Year" label="Per Year" />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Rate Term",
                                      values.camLogic.camRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Frequency <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camFrequency"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option value="Quarterly" label="Quarterly" />
                                      <option value="Half Yearly" label="Half Yearly" />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Frequency",
                                      values.camLogic.camFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Due Date <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <div className="row m-0">
                                      <div className="col-sm-6 ps-0">
                                        <Field
                                          type="number"
                                          name="camLogic.camDueDate"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-6 pe-0">
                                        <Field
                                          as="select"
                                          name="camLogic.camDueType"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option value="Working Day" label="Working Day" />
                                        </Field>
                                      </div>
                                      <div className="col-sm-12 p-0 mt-3">
                                        <Field
                                          as="select"
                                          name="camLogic.camDueFrequency"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Every Month" label="Every Month" />
                                          <option value="Subsequent Month" label="Subsequent Month" />
                                          <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                          <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                          <option value="Subsequent Year" label="Subsequent Year" />
                                          <option value="Next Financial Year" label="Next Financial Year" />
                                        </Field>
                                      </div>
                                    </div>



                                    {this.validator.message(
                                      "cam Due Date",
                                      values.camLogic.camDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Actualization <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camActualization"}
                                      onChange={(e) => {
                                        this.changeCamActualization(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Actualization",
                                      values.camLogic.camActualization,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {this.state.showCamActalization && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Actualization Basis (* Times Actual Cost) <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="camLogic.camActualizationBasis"
                                        />
                                        {this.validator.message(
                                          "CAM Actualization Basis",
                                          values.camLogic.camActualizationBasis,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Actualization Period (MM)
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="camLogic.camActualizationPeriod"
                                        />
                                        <ErrorMessage
                                          name="camLogic.camActualizationPeriod"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Capped <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name={"camLogic.camCapped"}
                                      onChange={(e) => {
                                        this.changeCamCapped(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Capped",
                                      values.camLogic.camCapped,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {this.state.showCamCapped && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped UOM <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"camLogic.camCappedUom"}
                                          onChange={(e) => {
                                            this.validator = new SimpleReactValidator({
                                              autoForceUpdate: this,
                                            });
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Per Sq Ft" label="Per Sq Ft" />
                                          <option value="Flat Amount" label="Flat Amount" />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Capped Uom",
                                          values.camLogic.camCappedUom,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    {values.camLogic.camCappedUom === "Per Sq Ft" && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          CAM Capped on Area <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name={"camLogic.camCappedOnArea"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Usable Area" label="Usable Area" />
                                            <option value="Carpet Area" label="Carpet Area" />
                                            <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped On Area",
                                            values.camLogic.camCappedOnArea,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped Rate <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="camLogic.camCappedRate"
                                        />
                                        {this.validator.message(
                                          "CAM Capped Rate",
                                          values.camLogic.camCappedRate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped Rate Term <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"camLogic.camCappedRateTerm"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Daily" label="Daily" />
                                          <option value="Monthly" label="Monthly" />
                                          <option value="Quarterly" label="Quarterly" />
                                          <option value="Half Yearly" label="Half Yearly" />
                                          <option value="Yearly" label="Yearly" />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Capped Rate Term",
                                          values.camLogic.camCappedRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            )}

                            {this.state.camBasisPureRevenueShareSalesRange && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="camLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => handleChange(e)}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="camLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => handleChange(e)}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="gridColOneByThree">
                                  <div className="newGridSectionInner">
                                    <label>Revenue Share (%)</label>
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    No. of SLABS <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="camLogic.slabNumber"
                                      value={this.state.initialValues.totalSlabs}
                                      className="slabInput"
                                      onChange={(e) => {
                                        this.addSlabRow(e);
                                        handleChange(e);
                                      }}
                                    />
                                    <ErrorMessage
                                      name="camLogic.slabNumber"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>

                                <div className="gridColOneByThree">
                                  <div className="tableContainer p-0">
                                    <table className="table tableSimple">
                                      <thead>
                                        <tr>
                                          <th scope="col">SLAB</th>
                                          <th scope="col">FROM</th>
                                          <th scope="col">To</th>
                                          <th scope="col">Revenue Share (%)</th>
                                          <th scope="col">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.initialValues.camLogic.slabs.length > 0 &&
                                          this.state.initialValues.camLogic.slabs.map((slab, index) => (
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>
                                                <Field
                                                  type="text"
                                                  name={`camLogic.slabs.${index}.from`}
                                                  onChange={(e) => {
                                                    this.state.initialValues.camLogic.slabs[index].from = e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  value={this.state.initialValues.camLogic.slabs[index].from}
                                                />
                                              </td>
                                              <td>
                                                <Field
                                                  type="text"
                                                  name={`camLogic.slabs.${index}.to`}
                                                  onChange={(e) => {
                                                    this.state.initialValues.camLogic.slabs[index].to = e.target.value;
                                                    handleChange(e);
                                                  }}
                                                  value={this.state.initialValues.camLogic.slabs[index].to}
                                                  onBlur={(e) => {
                                                    if (index < this.state.initialValues.camLogic.slabs.length - 1) {
                                                      this.getFromForNextSlab(e, values, index);
                                                    }
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <Field
                                                  type="text"
                                                  name={`camLogic.slabs.${index}.percent`}
                                                />
                                              </td>
                                              <td>
                                                <a
                                                  className="actionDelete"
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    this.state.initialValues.totalSlabs--;
                                                    const slabs = [...this.state.initialValues.camLogic.slabs];
                                                    slabs.splice(index, 1);
                                                    this.setState({ slabs });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </a>
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Rate Term <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camRateTerm"
                                      onChange={(e) => handleChange(e)}
                                    >
                                      <option value="" label="Select" />
                                      <option value="Per Month" label="Per Month" />
                                      <option value="Per Quarter" label="Per Quarter" />
                                      <option value="Per Half Year" label="Per Half Year" />
                                      <option value="Per Year" label="Per Year" />
                                      <option value="Per Day" label="Per Day" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Rate Term",
                                      values.camLogic.camRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Frequency <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camFrequency"
                                      onChange={(e) => handleChange(e)}
                                    >
                                      <option value="" label="Select" />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option value="Quarterly" label="Quarterly" />
                                      <option value="Half Yearly" label="Half Yearly" />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Frequency",
                                      values.camLogic.camFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Due Date <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <div className="row m-0">
                                      <div className="col-sm-6 ps-0">
                                        <Field
                                          type="number"
                                          onChange={(e) => handleChange(e)}
                                          name="camLogic.camDueDate"
                                        />
                                      </div>
                                      <div className="col-sm-6 pe-0">
                                        <Field
                                          as="select"
                                          onChange={(e) => handleChange(e)}
                                          name="camLogic.camDueType"
                                        >
                                          <option value="" label="Select" />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option value="Working Day" label="Working Day" />
                                        </Field>
                                      </div>
                                      <div className="col-sm-12 p-0 mt-3">
                                        <Field
                                          as="select"
                                          onChange={(e) => handleChange(e)}
                                          name="camLogic.camDueFrequency"
                                        >
                                          <option value="" label="Select" />
                                          <option value="Every Month" label="Every Month" />
                                          <option value="Subsequent Month" label="Subsequent Month" />
                                          <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                          <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                          <option value="Subsequent Year" label="Subsequent Year" />
                                          <option value="Next Financial Year" label="Next Financial Year" />
                                        </Field>
                                      </div>
                                    </div>
                                    <div>
                                      {this.validator.message(
                                        "cam Due Date",
                                        values.camLogic.camDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Actualization <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camActualization"
                                      onChange={(e) => {
                                        this.changeCamActualization(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Actualization",
                                      values.camLogic.camActualization,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                {this.state.showCamActualization && (
                                  <div className="newGridSectionInner">
                                    <label>
                                      CAM Actualization Basis (* Times Actual Cost)
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="camLogic.camActualizationBasis"
                                      />
                                      {this.validator.message(
                                        "CAM Actualization Basis",
                                        values.camLogic.camActualizationBasis,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                )}
                                {this.state.showCamActualization && (
                                  <div className="newGridSectionInner">
                                    <label>
                                      CAM Actualization Period (MM)
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="camLogic.camActualizationPeriod"
                                      />
                                      <ErrorMessage
                                        name="camLogic.camActualizationPeriod"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Capped <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camCapped"
                                      onChange={(e) => {
                                        this.changeCamCapped(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Capped",
                                      values.camLogic.camCapped,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                {this.state.showCamCapped && (
                                  <div className="newGridSectionInner">
                                    <label>
                                      CAM Capped UOM
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="camLogic.camCappedUom"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({ autoForceUpdate: this });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="Flat Amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "CAM Capped Uom",
                                        values.camLogic.camCappedUom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                )}
                                {values.camLogic.camCappedUom === "Per Sq Ft" && (
                                  <div className="newGridSectionInner">
                                    <label>
                                      CAM Capped on Area
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="camLogic.camCappedOnArea"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Usable Area" label="Usable Area" />
                                        <option value="Carpet Area" label="Carpet Area" />
                                        <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                      </Field>
                                      {this.validator.message(
                                        "CAM Capped On Area",
                                        values.camLogic.camCappedOnArea,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Capped Rate <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="camLogic.camCappedRate"
                                    />
                                    {this.validator.message(
                                      "CAM Capped Rate",
                                      values.camLogic.camCappedRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Capped Rate Term <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camCappedRateTerm"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option value="Quarterly" label="Quarterly" />
                                      <option value="Half Yearly" label="Half Yearly" />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Capped Rate Term",
                                      values.camLogic.camCappedRateTerm,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </>
                            )}

                            {this.state.camBasisPercentofRent && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="camLogic.fromDate"
                                      value={this.state.fromDate}
                                      onChange={(e) => handleChange(e)}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="camLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={(e) => handleChange(e)}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Frequency <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camFrequency"
                                      onChange={(e) => handleChange(e)}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option value="Quarterly" label="Quarterly" />
                                      <option value="Half Yearly" label="Half Yearly" />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Frequency",
                                      values.camLogic.camFrequency,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Due Date <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <div className="row m-0">
                                      <div className="col-sm-6 ps-0">
                                        <Field
                                          type="number"
                                          name="camLogic.camDueDate"
                                          onChange={(e) => handleChange(e)}
                                        />
                                      </div>
                                      <div className="col-sm-6 pe-0">
                                        <Field
                                          as="select"
                                          name="camLogic.camDueType"
                                          onChange={(e) => handleChange(e)}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option value="Working Day" label="Working Day" />
                                        </Field>
                                      </div>
                                      <div className="col-sm-12 p-0 mt-3">
                                        <Field
                                          as="select"
                                          name="camLogic.camDueFrequency"
                                          onChange={(e) => handleChange(e)}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Every Month" label="Every Month" />
                                          <option value="Subsequent Month" label="Subsequent Month" />
                                          <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                          <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                          <option value="Subsequent Year" label="Subsequent Year" />
                                          <option value="Next Financial Year" label="Next Financial Year" />
                                        </Field>
                                      </div>
                                    </div>
                                    {this.validator.message(
                                      "cam Due Date",
                                      values.camLogic.camDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM as Rent % <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="camLogic.camRentPercent"
                                      onChange={(e) => handleChange(e)}
                                    />
                                    {this.validator.message(
                                      "CAM as Rent %",
                                      values.camLogic.camRentPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    Applicable on Rent Period <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.applicableRentPeriod"
                                      onChange={(e) => handleChange(e)}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Daily" label="Daily" />
                                      <option value="Monthly" label="Monthly" />
                                      <option value="Quarterly" label="Quarterly" />
                                      <option value="Half Yearly" label="Half Yearly" />
                                      <option value="Yearly" label="Yearly" />
                                    </Field>
                                    {this.validator.message(
                                      "Cam Frequency",
                                      values.camLogic.applicableRentPeriod,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    Rent Rate <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="camLogic.rentRate"
                                      onChange={(e) => handleChange(e)}
                                    />
                                    <ErrorMessage
                                      name="camLogic.rentRate"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Actualization <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camActualization"
                                      onChange={(e) => {
                                        this.changeCamActualization(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Actualization",
                                      values.camLogic.camActualization,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {this.state.showCamActalization && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Actualization Basis (* Times Actual Cost)
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="camLogic.camActualizationBasis"
                                        />
                                        {this.validator.message(
                                          "CAM Actualization Basis",
                                          values.camLogic.camActualizationBasis,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Actualization Period (MM)
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="camLogic.camActualizationPeriod"
                                        />
                                        <ErrorMessage
                                          name="camLogic.camActualizationPeriod"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="newGridSectionInner">
                                  <label>
                                    CAM Capped <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      as="select"
                                      name="camLogic.camCapped"
                                      onChange={(e) => {
                                        this.changeCamCapped(e);
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" defaultValue />
                                      <option value="Yes" label="Yes" />
                                      <option value="No" label="No" />
                                    </Field>
                                    {this.validator.message(
                                      "CAM Capped",
                                      values.camLogic.camCapped,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>

                                {this.state.showCamCapped && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped UOM <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="camLogic.camCappedUom"
                                          onChange={(e) => {
                                            this.validator = new SimpleReactValidator({
                                              autoForceUpdate: this,
                                            });
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Per Sq Ft" label="Per Sq Ft" />
                                          <option value="Flat Amount" label="Flat Amount" />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Capped Uom",
                                          values.camLogic.camCappedUom,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    {values.camLogic.camCappedUom === "Per Sq Ft" && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          CAM Capped on Area <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="camLogic.camCappedOnArea"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Usable Area" label="Usable Area" />
                                            <option value="Carpet Area" label="Carpet Area" />
                                            <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped On Area",
                                            values.camLogic.camCappedOnArea,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped Rate <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="camLogic.camCappedRate"
                                        />
                                        {this.validator.message(
                                          "CAM Capped Rate",
                                          values.camLogic.camCappedRate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>
                                        CAM Capped Rate Term <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="camLogic.camCappedRateTerm"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Daily" label="Daily" />
                                          <option value="Monthly" label="Monthly" />
                                          <option value="Quarterly" label="Quarterly" />
                                          <option value="Half Yearly" label="Half Yearly" />
                                          <option value="Yearly" label="Yearly" />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Capped Rate Term",
                                          values.camLogic.camCappedRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                  </>
                                )}

                              </>
                            )}
                          </>
                        )}

                        <div className="gridColOneByThree">
                          <label>Notes/Remarks</label>
                          <Field as="textarea" className="my-2" name="notes_4" />
                        </div>
                      </div>
                      {this.state.showAddBtn && (
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          {this.state.isRentAutocalculate ===
                            false && (
                              <button
                                type="button"
                                className="add_button"
                                onClick={(e) => {
                                  this.addCamDetails(
                                    values,
                                    resetForm,
                                    setFieldValue
                                  );
                                }}
                              >
                                Add
                              </button>
                            )}
                          {this.state.isRentAutocalculate ===
                            true && (
                              <button
                                type="button"
                                className="update_button"
                                onClick={(e) => {
                                  this.calculateRent(values, resetForm);
                                }}
                              >
                                Create
                              </button>
                            )}
                          <button
                            type="button"
                            className="reset_button"
                            onClick={(e) => {
                              console.log(values, "nn");
                              this.resetCamDetails(values, resetForm);
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      )}

                      <div>
                        {this.mainFormValidator.message(
                          "Cam Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">CAM Logic</th>
                                <th scope="col">Rate/ Flat Amount</th>
                                <th scope="col" colSpan="">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.camDetails.map(function (name, index) {
                                return (
                                  <tr key={"camTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        className="popupLink"
                                        onClick={(e) => {
                                          this.state.popupData = name;
                                          this.openModal();
                                        }}
                                      >
                                        {name.period}
                                      </a>
                                    </td>
                                    <td>
                                      {name.periodTermYY == ""
                                        ? "0"
                                        : name.periodTermYY}
                                      {"-"}
                                      {name.periodTermMM == ""
                                        ? "0"
                                        : name.periodTermMM}
                                      {"-"}
                                      {name.periodTermDD == ""
                                        ? "0"
                                        : name.periodTermDD}
                                    </td>
                                    <td>
                                      {/* {dateFormat(name.fromDate, "dd mmm yyyy")} */}
                                      {leaseDateFormat(name.fromDate)}
                                    </td>
                                    <td>
                                      {/* {dateFormat(name.toDate, "dd mmm yyyy")} */}
                                      {leaseDateFormat(name.toDate)}
                                    </td>
                                    <td>{name.camLogicText}</td>
                                    <td>{name.camRate || "-"}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="tableActionEdit rentalEdit"
                                        onClick={(e) => {
                                          this.editCam(index, values);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPen} />
                                      </button>
                                      {this.state.camDetails.length ==
                                        index + 1 && (
                                          <button
                                            type="button"
                                            className="actionDelete rentalDeleteButton"
                                            onClick={(e) => {
                                              // if (
                                              //   window.confirm(
                                              //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                              //   )
                                              // ) {
                                              //   var _cam = this.state.camDetails;
                                              //   _cam.splice(index, 1);
                                              //   console.log(_cam, "new array");
                                              //   this.setState({
                                              //     camDetails: _cam,
                                              //     showForm: true,
                                              //   });
                                              //   this.state.period--;
                                              //   if (
                                              //     this.state.camDetails.length > 0
                                              //   ) {
                                              //     this.setState({
                                              //       fromDate: getToDate(
                                              //         this.state.camDetails[
                                              //           this.state.camDetails
                                              //             .length - 1
                                              //         ].toDate,
                                              //         2,
                                              //         0,
                                              //         0
                                              //       ),
                                              //     });
                                              //   } else {
                                              //     this.setState({
                                              //       fromDate: values.from,
                                              //     });
                                              //   }
                                              // }

                                              //this.handleReset()
                                              this.setState({
                                                delete: true,
                                                index_val: index,
                                                revalue: values.from,
                                              });
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                );
                              }, this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
                {/* <Form className="customTabs">
                  <div className="newGridSectionParent">
                    <div className="unitFormContainerNew leaseSection mb-4">
                      <div className="d-flex gap-5 mb-4">
                        <label>
                          <Field
                            type="checkbox"
                            style={{ width: 'min-content' }}
                            name="bifurcateRentCheckBox"
                            value="bifurcateRentCheckBox"
                            className="sameAs me-2"
                            checked={this.state.isUnitBifurcate}
                            disabled={
                              this.state.units.length === 1 ? true : false
                            }
                            onClick={(e) => {
                              this.biFurcateRent(e, values);
                            }}
                          />
                          BiFurcate Rent
                        </label>
                        <label>
                          <Field
                            type="checkbox"
                            name="autocalculateRentCheckBox"
                            style={{ width: 'min-content' }}
                            value="autocalculateRentCheckBox"
                            className="sameAs me-2"
                            checked={this.state.isRentCheckboxChecked}
                            onClick={(e) => {
                              this.autocalculateRent(e, values);
                            }}
                          />
                          Autocalculate Rent
                        </label>
                      </div>
                      <div className="row m-0">
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lease Term (YY-MM-DD){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-3 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermYY}
                                />
                              </div>
                              <div className="col-sm-2 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermMM}
                                />
                              </div>
                              <div className="col-sm-2 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermDD}
                                />
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lease Renewal Term (YY-MM-DD){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-3 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermYY}
                                />
                              </div>
                              <div className="col-sm-2 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermMM}
                                />
                              </div>
                              <div className="col-sm-2 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermDD}
                                />
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row m-0">
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                From
                              </label>
                              <div className="col-sm-7">
                                <Field type="date" name="from" />
                                <ErrorMessage
                                  name="from"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                To
                              </label>
                              <div className="col-sm-7">
                                <Field type="date" name="to" />
                                <ErrorMessage
                                  name="to"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row m-0">
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                CAM Applicable <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  as="select"
                                  name={"camApplicable"}
                                  value={this.state.applicableValue}
                                  onChange={(e) => {
                                    this.state.applicableValue = e.target.value;
                                    this.showCamForm(e);
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="yes" label="Yes" />
                                  <option value="no" label="No" />
                                </Field>
                                {this.applicableValidator.message(
                                  "CAM Applicable",
                                  this.state.applicableValue,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.showForm && (
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  CAM Paid At <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field
                                    as="select"
                                    name={"camLogic.camPaidAt"}
                                    disabled={this.state.disableOnEdit}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option value="average" label="Average" />
                                    <option value="actual" label="Actual" />
                                  </Field>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.biFurcateRentVal === 1 && (
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Unit <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field
                                    as="select"
                                    name={"camLogic.unit"}
                                    disabled={this.state.disableOnEdit}
                                    value={
                                      this.state.initialValues.camLogic.unit
                                    }
                                    onChange={(e) => {
                                      this.handleUnitOnChange(e, values);
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    {this.state.units.map((obj) => (
                                      <option key={obj.id} value={obj.unitNo}>
                                        {obj.unitNo}
                                      </option>
                                    ))}
                                  </Field>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {this.state.toggleCamForm && (
                        <div className="camApplicable">
                          {this.state.isRentAutocalculate === false &&
                            this.state.showForm && (
                              <div className="row m-0">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="text"
                                          name="camLogic.period"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.period}
                                          onChange={(e) => {
                                            this.state.period = e.target.value;
                                          }}
                                        />
                                        <ErrorMessage
                                          name="camLogic.period"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period Term
                                      </label>
                                      <div className="col-sm-3 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="periodTermmYY"
                                          placeholder="YY"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermYY}
                                          onChange={(e) => {
                                            this.state.periodTermYY =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="periodTermMM"
                                          placeholder="MM"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermMM}
                                          onChange={(e) => {
                                            this.state.periodTermMM =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="periodTermDD"
                                          placeholder="DD"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermDD}
                                          onChange={(e) => {
                                            this.state.periodTermDD =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <ErrorMessage
                                        name="camLogic.periodTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                          {this.state.isRentAutocalculate === true && (
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Escalation %
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        type="number"
                                        name="camLogic.escalationPercent"
                                        disabled={this.state.disableOnEdit}
                                      />
                                      {this.validator.message(
                                        "Escalation %",
                                        values.camLogic.escalationPercent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Period Duration
                                    </label>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="periodDurationYY"
                                        placeholder="YY"
                                        disabled={this.state.disableOnEdit}
                                        className="centerPlaceHolder text-center"
                                        value={this.state.periodDurationYY}
                                        onChange={(e) => {
                                          this.state.periodDurationYY =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="periodDurationMM"
                                        placeholder="MM"
                                        disabled={this.state.disableOnEdit}
                                        className="centerPlaceHolder text-center"
                                        value={this.state.periodDurationMM}
                                        onChange={(e) => {
                                          this.state.periodDurationMM =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="periodDurationDD"
                                        placeholder="DD"
                                        disabled={this.state.disableOnEdit}
                                        className="centerPlaceHolder text-center"
                                        value={this.state.periodDurationDD}
                                        onChange={(e) => {
                                          this.state.periodDurationDD =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="rentalLogic.periodDuration"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {this.state.showForm && (
                            <div className="row m-0">
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label">
                                      CAM Logic{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-10 logicDropdownWidthDesktop">
                                      <Field
                                        as="select"
                                        name={"camLogic.camLogicValue"}
                                        // disabled={this.state.disableOnEdit}
                                        value={
                                          this.state.initialValues.camLogic
                                            .camLogicValue
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                          this.hadleCamLogicChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option
                                          value="1"
                                          label="CAM Basis Rate"
                                        />
                                        {this.state.isRentAutocalculate ===
                                          false && (
                                            <>
                                              <option
                                                value="2"
                                                label="CAM Basis Pure Revenue Share"
                                              />
                                              <option
                                                value="3"
                                                label="CAM Basis Pure Revenue Share Sales Range"
                                              />
                                              <option
                                                value="4"
                                                label="CAM Basis % of Rent"
                                              />
                                            </>
                                          )}
                                      </Field>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {this.state.camBasisRate && (
                            <div className="camBasisRate">
                              <div className="row m-0">
                                {this.state.isRentAutocalculate === false && (
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="camLogic.fromDate"
                                            readOnly={true}
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {this.state.isRentAutocalculate === false && (
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="camLogic.toDate"
                                            readOnly={true}
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM UOM{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camUom"}
                                          onChange={(e) => {
                                            this.validator =
                                              new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" />
                                          <option
                                            value="Per Sq Ft"
                                            label="Per Sq Ft"
                                          />
                                          <option
                                            value="Flat Amount"
                                            label="Flat Amount"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam UOM",
                                          values.camLogic.camUom,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {values.camLogic.camUom == "Per Sq Ft" && (
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.onArea"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Usable Area"
                                              label="Usable Area"
                                            />
                                            <option
                                              value="Carpet Area"
                                              label="Carpet Area"
                                            />
                                            <option
                                              value="Gross Leasable Area"
                                              label="Gross Leasable Area"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "On Area",
                                            values.camLogic.onArea,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {this.state.period > 1 &&
                                  typeof this.state.camDetails[
                                  this.state.escalationIndex
                                  ] !== "undefined" &&
                                  this.state.camDetails[
                                    this.state.escalationIndex
                                  ].camRate !== 0 &&
                                  this.state.isRentAutocalculate === false && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Escalation %
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="camLogic.escalationPercent"
                                              disabled={
                                                this.state.disableOnEdit
                                              }
                                              onBlur={(e) => {
                                                this.calculateRentRate(
                                                  e,
                                                  values,
                                                  setFieldValue
                                                );
                                              }}
                                            />
                                            {this.validator.message(
                                              "Escalation %",
                                              values.camLogic.escalationPercent,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Rate{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="camLogic.camRate"
                                          onBlur={(e) => {
                                            this.calculateEscalationPercent(
                                              e,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        />
                                        {this.validator.message(
                                          "Cam Rate",
                                          values.camLogic.camRate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Rate Term{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camRateTerm"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Per Month"
                                            label="Per Month"
                                          />
                                          <option
                                            value="Per Quarter"
                                            label="Per Quarter"
                                          />
                                          <option
                                            value="Per Half Year"
                                            label="Per Half Year"
                                          />
                                          <option
                                            value="Per Year"
                                            label="Per Year"
                                          />
                                          <option
                                            value="Per Day"
                                            label="Per Day"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Rate Term",
                                          values.camLogic.camRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Frequency
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camFrequency"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Daily" label="Daily" />
                                          <option
                                            value="Monthly"
                                            label="Monthly"
                                          />
                                          <option
                                            value="Quarterly"
                                            label="Quarterly"
                                          />
                                          <option
                                            value="Half Yearly"
                                            label="Half Yearly"
                                          />
                                          <option
                                            value="Yearly"
                                            label="Yearly"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Frequency",
                                          values.camLogic.camFrequency,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Due Date{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          type="number"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueDate"
                                        ></Field>
                                      </div>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueType"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option
                                            value="Working Day"
                                            label="Working Day"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4 mt-3">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueFrequency"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Every Month"
                                            label="Every Month"
                                          />
                                          <option
                                            value="Subsequent Month"
                                            label="Subsequent Month"
                                          />
                                          <option
                                            value="Subsequent Quarter"
                                            label="Subsequent Quarter"
                                          />
                                          <option
                                            value="Subsequent Half Year"
                                            label="Subsequent Half Year"
                                          />
                                          <option
                                            value="Subsequent Year"
                                            label="Subsequent Year"
                                          />
                                          <option
                                            value="Next Financial Year"
                                            label="Next Financial Year"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4">
                                        {this.validator.message(
                                          "cam Due Date",
                                          values.camLogic.camDueDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="actualization">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Actualization
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camActualization"}
                                            onChange={(e) => {
                                              this.changeCamActualization(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Actualization",
                                            values.camLogic.camActualization,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamActalization && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Basis (* Times
                                            Actual Cost)
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationBasis"
                                            />
                                            {this.validator.message(
                                              "CAM Actualization Basis",
                                              values.camLogic
                                                .camActualizationBasis,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Period (MM)
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationPeriod"
                                            />
                                            <ErrorMessage
                                              name="camLogic.camActualizationPeriod"
                                              component="div"
                                              className="text-red"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="capped">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camCapped"}
                                            onChange={(e) => {
                                              this.changeCamCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped",
                                            values.camLogic.camCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"camLogic.camCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Uom",
                                              values.camLogic.camCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.camLogic.camCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                CAM Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "camLogic.camCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "CAM Capped On Area",
                                                  values.camLogic.camCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="camLogic.camCappedRate"
                                            />
                                            {this.validator.message(
                                              "CAM Capped Rate",
                                              values.camLogic.camCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "camLogic.camCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Daily"
                                                label="Daily"
                                              />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Rate Term",
                                              values.camLogic.camCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {this.state.camBasisPureRevenueShare && (
                            <div className="camBasisPureRevenueShare">
                              <div className="row m-0">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        From <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="date"
                                          name="camLogic.fromDate"
                                          value={this.state.fromDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "From",
                                          this.state.fromDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        To <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="date"
                                          name="camLogic.toDate"
                                          value={this.state.toDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "To",
                                          this.state.toDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Revenue Share (%){" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="camLogic.revenueShare"
                                        />
                                        {this.validator.message(
                                          "Revenue Share",
                                          values.camLogic.revenueShare,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Rate Term{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camRateTerm"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Per Month"
                                            label="Per Month"
                                          />
                                          <option
                                            value="Per Quarter"
                                            label="Per Quarter"
                                          />
                                          <option
                                            value="Per Half Year"
                                            label="Per Half Year"
                                          />
                                          <option
                                            value="Per Year"
                                            label="Per Year"
                                          />
                                          <option
                                            value="Per Day"
                                            label="Per Day"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Rate Term",
                                          values.camLogic.camRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Frequency
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camFrequency"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Daily" label="Daily" />
                                          <option
                                            value="Monthly"
                                            label="Monthly"
                                          />
                                          <option
                                            value="Quarterly"
                                            label="Quarterly"
                                          />
                                          <option
                                            value="Half Yearly"
                                            label="Half Yearly"
                                          />
                                          <option
                                            value="Yearly"
                                            label="Yearly"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Frequency",
                                          values.camLogic.camFrequency,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Due Date{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          type="number"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueDate"
                                        ></Field>
                                      </div>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueType"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option
                                            value="Working Day"
                                            label="Working Day"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4 mt-3">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueFrequency"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Every Month"
                                            label="Every Month"
                                          />
                                          <option
                                            value="Subsequent Month"
                                            label="Subsequent Month"
                                          />
                                          <option
                                            value="Subsequent Quarter"
                                            label="Subsequent Quarter"
                                          />
                                          <option
                                            value="Subsequent Half Year"
                                            label="Subsequent Half Year"
                                          />
                                          <option
                                            value="Subsequent Year"
                                            label="Subsequent Year"
                                          />
                                          <option
                                            value="Next Financial Year"
                                            label="Next Financial Year"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4">
                                        {this.validator.message(
                                          "cam Due Date",
                                          values.camLogic.camDueDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="actualization">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Actualization
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camActualization"}
                                            onChange={(e) => {
                                              this.changeCamActualization(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Actualization",
                                            values.camLogic.camActualization,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamActalization && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Basis (* Times
                                            Actual Cost)
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationBasis"
                                            />
                                            {this.validator.message(
                                              "CAM Actualization Basis",
                                              values.camLogic
                                                .camActualizationBasis,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Period (MM)
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationPeriod"
                                            />
                                            <ErrorMessage
                                              name="camLogic.camActualizationPeriod"
                                              component="div"
                                              className="text-red"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="capped">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camCapped"}
                                            onChange={(e) => {
                                              this.changeCamCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped",
                                            values.camLogic.camCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"camLogic.camCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Uom",
                                              values.camLogic.camCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.camLogic.camCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                CAM Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "camLogic.camCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "CAM Capped On Area",
                                                  values.camLogic.camCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="camLogic.camCappedRate"
                                            />
                                            {this.validator.message(
                                              "CAM Capped Rate",
                                              values.camLogic.camCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "camLogic.camCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Daily"
                                                label="Daily"
                                              />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Rate Term",
                                              values.camLogic.camCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {this.state.camBasisPureRevenueShareSalesRange && (
                            <div className="camBasisPureRevenueShareSalesRange">
                              <div className="row m-0">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        From <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="date"
                                          name="camLogic.fromDate"
                                          value={this.state.fromDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "From",
                                          this.state.fromDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        To <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="date"
                                          name="camLogic.toDate"
                                          value={this.state.toDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "To",
                                          this.state.toDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12 p-0">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="gridColOneByThree textWithHrTag bigFonrSize">
                                      <h4>Revenue Share (%)</h4>
                                      <hr className="m-0" />
                                    </div>
                                    <div className="tableContainer p-0">
                                      <div className="col-lg-6 mb-4">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row m-0">
                                            <label className="col-sm-3 ps-0 col-form-label">
                                              No. of SLABS{" "}
                                              <span className="astrik">
                                                *
                                              </span>
                                            </label>
                                            <div className="col-sm-7 pe-0">
                                              <Field
                                                type="text"
                                                name="camLogic.slabNumber"
                                                value={
                                                  this.state.initialValues
                                                    .totalSlabs
                                                }
                                                className="slabInput"
                                                onChange={(e) => {
                                                  this.addSlabRow(e);
                                                  handleChange(e);
                                                }}
                                              />
                                              <ErrorMessage
                                                name="camLogic.slabNumber"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <table className="table tableSimple">
                                        <thead>
                                          <tr>
                                            <th scope="col">SLAB</th>
                                            <th scope="col">FROM</th>
                                            <th scope="col">To</th>
                                            <th scope="col">
                                              Revenue Share (%)
                                            </th>
                                            <th scope="col" colSpan="">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.initialValues.camLogic
                                            .slabs.length > 0 &&
                                            this.state.initialValues.camLogic.slabs.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`camLogic.slabs.${index}.from`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.camLogic.slabs[
                                                          index
                                                        ].from =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state
                                                          .initialValues
                                                          .camLogic.slabs[
                                                          index
                                                        ].from
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`camLogic.slabs.${index}.to`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.camLogic.slabs[
                                                          index
                                                        ].to =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state
                                                          .initialValues
                                                          .camLogic.slabs[
                                                          index
                                                        ].to
                                                      }
                                                      onBlur={(e) => {
                                                        if (
                                                          index <
                                                          this.state
                                                            .initialValues
                                                            .camLogic.slabs
                                                            .length -
                                                          1
                                                        ) {
                                                          this.getFromForNextSlab(
                                                            e,
                                                            values,
                                                            index
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`camLogic.slabs.${index}.percent`}
                                                    />
                                                  </td>
                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={(e) => {
                                                        this.state
                                                          .initialValues
                                                          .totalSlabs--;
                                                        var _slabs =
                                                          this.state
                                                            .initialValues
                                                            .camLogic.slabs;
                                                        _slabs.splice(
                                                          index,
                                                          1
                                                        );
                                                        this.setState({
                                                          slabs: _slabs,
                                                        });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Rate Term{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camRateTerm"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Per Month"
                                            label="Per Month"
                                          />
                                          <option
                                            value="Per Quarter"
                                            label="Per Quarter"
                                          />
                                          <option
                                            value="Per Half Year"
                                            label="Per Half Year"
                                          />
                                          <option
                                            value="Per Year"
                                            label="Per Year"
                                          />
                                          <option
                                            value="Per Day"
                                            label="Per Day"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Rate Term",
                                          values.camLogic.camRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Frequency
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camFrequency"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Daily" label="Daily" />
                                          <option
                                            value="Monthly"
                                            label="Monthly"
                                          />
                                          <option
                                            value="Quarterly"
                                            label="Quarterly"
                                          />
                                          <option
                                            value="Half Yearly"
                                            label="Half Yearly"
                                          />
                                          <option
                                            value="Yearly"
                                            label="Yearly"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Frequency",
                                          values.camLogic.camFrequency,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Due Date{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          type="number"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueDate"
                                        ></Field>
                                      </div>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueType"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option
                                            value="Working Day"
                                            label="Working Day"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4 mt-3">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueFrequency"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Every Month"
                                            label="Every Month"
                                          />
                                          <option
                                            value="Subsequent Month"
                                            label="Subsequent Month"
                                          />
                                          <option
                                            value="Subsequent Quarter"
                                            label="Subsequent Quarter"
                                          />
                                          <option
                                            value="Subsequent Half Year"
                                            label="Subsequent Half Year"
                                          />
                                          <option
                                            value="Subsequent Year"
                                            label="Subsequent Year"
                                          />
                                          <option
                                            value="Next Financial Year"
                                            label="Next Financial Year"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4">
                                        {this.validator.message(
                                          "cam Due Date",
                                          values.camLogic.camDueDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="actualization">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Actualization
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camActualization"}
                                            onChange={(e) => {
                                              this.changeCamActualization(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Actualization",
                                            values.camLogic.camActualization,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamActalization && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Basis (* Times
                                            Actual Cost)
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationBasis"
                                            />
                                            {this.validator.message(
                                              "CAM Actualization Basis",
                                              values.camLogic
                                                .camActualizationBasis,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Period (MM)
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationPeriod"
                                            />
                                            <ErrorMessage
                                              name="camLogic.camActualizationPeriod"
                                              component="div"
                                              className="text-red"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="capped">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camCapped"}
                                            onChange={(e) => {
                                              this.changeCamCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped",
                                            values.camLogic.camCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"camLogic.camCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Uom",
                                              values.camLogic.camCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.camLogic.camCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                CAM Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "camLogic.camCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "CAM Capped On Area",
                                                  values.camLogic.camCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="camLogic.camCappedRate"
                                            />
                                            {this.validator.message(
                                              "CAM Capped Rate",
                                              values.camLogic.camCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "camLogic.camCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Daily"
                                                label="Daily"
                                              />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Rate Term",
                                              values.camLogic.camCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {this.state.camBasisPercentofRent && (
                            <div className="camBasisPercentofRent">
                              <div className="row m-0">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        From <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="date"
                                          name="camLogic.fromDate"
                                          value={this.state.fromDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "From",
                                          this.state.fromDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        To <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="date"
                                          name="camLogic.toDate"
                                          value={this.state.toDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "To",
                                          this.state.toDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Frequency
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.camFrequency"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Daily" label="Daily" />
                                          <option
                                            value="Monthly"
                                            label="Monthly"
                                          />
                                          <option
                                            value="Quarterly"
                                            label="Quarterly"
                                          />
                                          <option
                                            value="Half Yearly"
                                            label="Half Yearly"
                                          />
                                          <option
                                            value="Yearly"
                                            label="Yearly"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Frequency",
                                          values.camLogic.camFrequency,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM Due Date{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          type="number"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueDate"
                                        ></Field>
                                      </div>
                                      <div className="col-sm-3 dueDateFieldWidth">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueType"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Date" label="Date" />
                                          <option value="Days" label="Days" />
                                          <option
                                            value="Working Day"
                                            label="Working Day"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4 mt-3">
                                        <Field
                                          as="select"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                          name="camLogic.camDueFrequency"
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Every Month"
                                            label="Every Month"
                                          />
                                          <option
                                            value="Subsequent Month"
                                            label="Subsequent Month"
                                          />
                                          <option
                                            value="Subsequent Quarter"
                                            label="Subsequent Quarter"
                                          />
                                          <option
                                            value="Subsequent Half Year"
                                            label="Subsequent Half Year"
                                          />
                                          <option
                                            value="Subsequent Year"
                                            label="Subsequent Year"
                                          />
                                          <option
                                            value="Next Financial Year"
                                            label="Next Financial Year"
                                          />
                                        </Field>
                                      </div>
                                      <div className="col-sm-7 offset-sm-4">
                                        {this.validator.message(
                                          "cam Due Date",
                                          values.camLogic.camDueDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        CAM as Rent %{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="camLogic.camRentPercent"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "CAM as Rent %",
                                          values.camLogic.camRentPercent,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Applicable on Rent Period
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          as="select"
                                          name={"camLogic.applicableRentPeriod"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="Daily" label="Daily" />
                                          <option
                                            value="Monthly"
                                            label="Monthly"
                                          />
                                          <option
                                            value="Quarterly"
                                            label="Quarterly"
                                          />
                                          <option
                                            value="Half Yearly"
                                            label="Half Yearly"
                                          />
                                          <option
                                            value="Yearly"
                                            label="Yearly"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "Cam Frequency",
                                          values.camLogic.applicableRentPeriod,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Rent Rate{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="number"
                                          name="camLogic.rentRate"
                                        />
                                        <ErrorMessage
                                          name="camLogic.rentRate"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="actualization">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Actualization
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camActualization"}
                                            onChange={(e) => {
                                              this.changeCamActualization(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Actualization",
                                            values.camLogic.camActualization,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamActalization && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Basis (* Times
                                            Actual Cost)
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationBasis"
                                            />
                                            {this.validator.message(
                                              "CAM Actualization Basis",
                                              values.camLogic
                                                .camActualizationBasis,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization Period (MM)
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="text"
                                              name="camLogic.camActualizationPeriod"
                                            />
                                            <ErrorMessage
                                              name="camLogic.camActualizationPeriod"
                                              component="div"
                                              className="text-red"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="capped">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"camLogic.camCapped"}
                                            onChange={(e) => {
                                              this.changeCamCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Yes" label="Yes" />
                                            <option value="No" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Capped",
                                            values.camLogic.camCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showCamCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"camLogic.camCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Uom",
                                              values.camLogic.camCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.camLogic.camCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                CAM Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "camLogic.camCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "CAM Capped On Area",
                                                  values.camLogic.camCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="camLogic.camCappedRate"
                                            />
                                            {this.validator.message(
                                              "CAM Capped Rate",
                                              values.camLogic.camCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "camLogic.camCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Daily"
                                                label="Daily"
                                              />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "CAM Capped Rate Term",
                                              values.camLogic.camCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}


                          {this.state.showAddBtn && (
                            <div className="row m-0">
                              <div className="col-lg-6 offset-lg-6">
                                <div className="btnContainer">
                                  <div>
                                    {this.state.isRentAutocalculate ===
                                      false && (
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            this.addCamDetails(
                                              values,
                                              resetForm,
                                              setFieldValue
                                            );
                                          }}
                                        >
                                          Add
                                        </button>
                                      )}
                                    {this.state.isRentAutocalculate ===
                                      true && (
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            this.calculateRent(values, resetForm);
                                          }}
                                        >
                                          Create
                                        </button>
                                      )}
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        console.log(values, "nn");
                                        this.resetCamDetails(values, resetForm);
                                      }}
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      <span className="remarks">Notes/Remarks</span>
                      <Field as="textarea" className="notes mb-3" name="notes_6" />
                    </div>

                    <div>
                      {this.mainFormValidator.message(
                        "Cam Details",
                        this.countError,
                        "required",
                        { className: "text-danger" }
                      )}
                      <div className="tableContainer p-0">
                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th scope="col">S.No</th>
                              <th scope="col">Period</th>
                              <th scope="col">Period Term</th>
                              <th scope="col">From</th>
                              <th scope="col">To</th>
                              <th scope="col">CAM Logic</th>
                              <th scope="col">Rate/ Flat Amount</th>
                              <th scope="col" colSpan="">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.camDetails.map(function (name, index) {
                              return (
                                <tr key={"camTable" + index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <a
                                      className="popupLink"
                                      onClick={(e) => {
                                        this.state.popupData = name;
                                        this.openModal();
                                      }}
                                    >
                                      {name.period}
                                    </a>
                                  </td>
                                  <td>
                                    {name.periodTermYY == ""
                                      ? "0"
                                      : name.periodTermYY}
                                    {"-"}
                                    {name.periodTermMM == ""
                                      ? "0"
                                      : name.periodTermMM}
                                    {"-"}
                                    {name.periodTermDD == ""
                                      ? "0"
                                      : name.periodTermDD}
                                  </td>
                                  <td>
                                    {leaseDateFormat(name.fromDate)}
                                  </td>
                                  <td>
                                    {leaseDateFormat(name.toDate)}
                                  </td>
                                  <td>{name.camLogicText}</td>
                                  <td>{name.camRate || "-"}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="tableActionEdit rentalEdit"
                                      onClick={(e) => {
                                        this.editCam(index, values);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPen} />
                                    </button>
                                    {this.state.camDetails.length ==
                                      index + 1 && (
                                        <button
                                          type="button"
                                          className="actionDelete rentalDeleteButton"
                                          onClick={(e) => {
                                            // if (
                                            //   window.confirm(
                                            //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                            //   )
                                            // ) {
                                            //   var _cam = this.state.camDetails;
                                            //   _cam.splice(index, 1);
                                            //   console.log(_cam, "new array");
                                            //   this.setState({
                                            //     camDetails: _cam,
                                            //     showForm: true,
                                            //   });
                                            //   this.state.period--;
                                            //   if (
                                            //     this.state.camDetails.length > 0
                                            //   ) {
                                            //     this.setState({
                                            //       fromDate: getToDate(
                                            //         this.state.camDetails[
                                            //           this.state.camDetails
                                            //             .length - 1
                                            //         ].toDate,
                                            //         2,
                                            //         0,
                                            //         0
                                            //       ),
                                            //     });
                                            //   } else {
                                            //     this.setState({
                                            //       fromDate: values.from,
                                            //     });
                                            //   }
                                            // }

                                            //this.handleReset()
                                            this.setState({
                                              delete: true,
                                              index_val: index,
                                              revalue: values.from,
                                            });
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                      )}
                                  </td>
                                </tr>
                              );
                            }, this)}
                          </tbody>
                        </table>
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button type="submit" className="add_button">
                            Save Draft
                          </button>
                          <button type="reset" className="reset_button">
                            <Link to="/createlease">
                              Cancel
                            </Link>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form> */}
              </>
            )}
          </Formik>
        </div>
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row m-0">
                        <div className="col-lg-12">
                          <ul>
                            <li>Cam Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.camPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  camPopup(cam) {
    console.log(cam);
    if (cam.camLogicValue == 1) {
      return this.camBasisRatePopup(cam);
    } else if (cam.camLogicValue == 2) {
      return this.camBasisPureRevenueSharePopup(cam);
    } else if (cam.camLogicValue == 3) {
      return this.camBasisPureRevenueShareSalesRangePopup(cam);
    } else if (cam.camLogicValue == 4) {
      return this.camBasisPercentofRent(cam);
    }
  }

  camBasisRatePopup(cam) {
    if (this.state.isRentAutocalculate === false) {
      return (
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.periodTermYY == "" ? "0" : cam.periodTermYY}
                    {"-"}
                    {cam.periodTermMM == "" ? "0" : cam.periodTermMM}
                    {"-"}
                    {cam.periodTermDD == "" ? "0" : cam.periodTermDD}
                  </label>
                </div>
              </div>
            </div>
            {cam.unit !== undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.unit}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    CAM Paid At <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camPaidAt === undefined ? "-" : cam.camPaidAt}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <label className="col-sm-4 col-form-label">
                      From <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {leaseDateFormat(cam.fromDate)}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(cam.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row m-0">
            <div className="row mb-3">
              <div className="col-lg-12 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Actualization <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camActualization}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {cam.camActualization == "Yes" && (
              <div className="camAct row">
                <div className="col-lg-6 fitoutPopup">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-0">
                      <label
                        className="col-sm-4 col-form-label"
                        style={{ fontWeight: "500", fontSize: "14px" }}
                      >
                        CAM Actualization Basis (* Times Actual Cost){" "}
                        <span className="astrik">*</span>
                      </label>
                      <label
                        className="col-sm-7 col-form-label"
                        style={{ fontSize: "14px" }}
                      >
                        {cam.camActualizationBasis}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 fitoutPopup">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Actualization Period{" "}
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camActualizationPeriod}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="row m-0">
            <div className="col-lg-12">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    CAM Capped <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camCapped}
                  </label>
                </div>
              </div>
            </div>
            {cam.camActualization == "Yes" && (
              <div className="camCapped row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped UOM <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedUom}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped on Area <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedOnArea}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped Rate <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedRate}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped Rate Term <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedRateTerm}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.periodTermYY == "" ? "0" : cam.periodTermYY}
                    {"-"}
                    {cam.periodTermMM == "" ? "0" : cam.periodTermMM}
                    {"-"}
                    {cam.periodTermDD == "" ? "0" : cam.periodTermDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
            {cam.unit !== undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.unit}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <label className="col-sm-4 col-form-label">
                      From <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {leaseDateFormat(cam.fromDate)}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(cam.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Cam Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row m-0">
            <div className="row mb-3">
              <div className="col-lg-12 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Actualization <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camActualization}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {cam.camActualization == "Yes" && (
              <div className="camAct row">
                <div className="col-lg-6 fitoutPopup">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-0">
                      <label
                        className="col-sm-4 col-form-label"
                        style={{ fontWeight: "500", fontSize: "14px" }}
                      >
                        CAM Actualization Basis (* Times Actual Cost){" "}
                        <span className="astrik">*</span>
                      </label>
                      <label
                        className="col-sm-7 col-form-label"
                        style={{ fontSize: "14px" }}
                      >
                        {cam.camActualizationBasis}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 fitoutPopup">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Actualization Period{" "}
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camActualizationPeriod}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="row m-0">
            <div className="col-lg-12">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    CAM Capped <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camCapped}
                  </label>
                </div>
              </div>
            </div>
            {cam.camActualization == "Yes" && (
              <div className="camCapped row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped UOM <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedUom}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped on Area <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedOnArea}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped Rate <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedRate}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        CAM Capped Rate Term <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {cam.camCappedRateTerm}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  camBasisPureRevenueSharePopup(cam) {
    return (
      <div className="container">
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.periodTermYY == "" ? "0" : cam.periodTermYY}
                  {"-"}
                  {cam.periodTermMM == "" ? "0" : cam.periodTermMM}
                  {"-"}
                  {cam.periodTermDD == "" ? "0" : cam.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          {cam.unit !== undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Unit <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">{cam.unit}</label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Paid At <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camPaidAt === undefined ? "-" : cam.camPaidAt}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(cam.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(cam.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="row m-0">
            <div className="col-lg-12 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    CAM Actualization <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camActualization}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {cam.camActualization == "Yes" && (
            <div className="camAct row">
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-0">
                    <label
                      className="col-sm-4 col-form-label"
                      style={{ fontWeight: "500", fontSize: "14px" }}
                    >
                      CAM Actualization Basis (* Times Actual Cost){" "}
                      <span className="astrik">*</span>
                    </label>
                    <label
                      className="col-sm-7 col-form-label"
                      style={{ fontSize: "14px" }}
                    >
                      {cam.camActualizationBasis}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Actualization Period <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camActualizationPeriod}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row m-0">
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camCapped}
                </label>
              </div>
            </div>
          </div>
          {cam.camActualization == "Yes" && (
            <div className="camCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  camBasisPureRevenueShareSalesRangePopup(cam) {
    return (
      <div className="container">
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.periodTermYY == "" ? "0" : cam.periodTermYY}
                  {"-"}
                  {cam.periodTermMM == "" ? "0" : cam.periodTermMM}
                  {"-"}
                  {cam.periodTermDD == "" ? "0" : cam.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          {cam.unit !== undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Unit <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">{cam.unit}</label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Paid At <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camPaidAt === undefined ? "-" : cam.camPaidAt}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(cam.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(cam.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cam.slabs.length > 0 &&
                          cam.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="row m-0">
            <div className="col-lg-12 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    CAM Actualization <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camActualization}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {cam.camActualization == "Yes" && (
            <div className="camAct row">
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-0">
                    <label
                      className="col-sm-4 col-form-label"
                      style={{ fontWeight: "500", fontSize: "14px" }}
                    >
                      CAM Actualization Basis (* Times Actual Cost){" "}
                      <span className="astrik">*</span>
                    </label>
                    <label
                      className="col-sm-7 col-form-label"
                      style={{ fontSize: "14px" }}
                    >
                      {cam.camActualizationBasis}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Actualization Period <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camActualizationPeriod}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row m-0">
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camCapped}
                </label>
              </div>
            </div>
          </div>
          {cam.camActualization == "Yes" && (
            <div className="camCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  camBasisPercentofRent(cam) {
    return (
      <div className="container">
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.periodTermYY == "" ? "0" : cam.periodTermYY}
                  {"-"}
                  {cam.periodTermMM == "" ? "0" : cam.periodTermMM}
                  {"-"}
                  {cam.periodTermDD == "" ? "0" : cam.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          {cam.unit !== undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Unit <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">{cam.unit}</label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Paid At <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camPaidAt === undefined ? "-" : cam.camPaidAt}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(cam.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(cam.toDate)}
                </label>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.camUom}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.onArea}</label>
              </div>
            </div>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.camRate}</label>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camRateTerm}
                </label>
              </div>
            </div>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM as Rent % <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camRentPercent}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Applicable on Rent Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.applicableRentPeriod}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="row m-0">
            <div className="col-lg-12 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    CAM Actualization <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {cam.camActualization}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {cam.camActualization == "Yes" && (
            <div className="camAct row">
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-0">
                    <label
                      className="col-sm-4 col-form-label"
                      style={{ fontWeight: "500", fontSize: "14px" }}
                    >
                      CAM Actualization Basis (* Times Actual Cost){" "}
                      <span className="astrik">*</span>
                    </label>
                    <label
                      className="col-sm-7 col-form-label"
                      style={{ fontSize: "14px" }}
                    >
                      {cam.camActualizationBasis}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Actualization Period <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camActualizationPeriod}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row m-0">
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CAM Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camCapped}
                </label>
              </div>
            </div>
          </div>
          {cam.camActualization == "Yes" && (
            <div className="camCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      CAM Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {cam.camCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(CamDetails);
